// extracted by mini-css-extract-plugin
export default {"container":"UpdatingAlert_container__7J769","content":"UpdatingAlert_content__9nqfP","icon":"UpdatingAlert_icon__iCIuP","jump":"UpdatingAlert_jump__pVx6N"};